import React from 'react';

class InstantQuote extends React.Component {
  constructor(props) {
    super(props);
    // this.onClick = this.onClick.bind(this);
    // this.prepareData = this.prepareData.bind(this);
  }

  // onClick() {
  // {/* Validate Form Complete o Section in case of Bundle Product*/}
  //
  // {/*
  //   if (!vfIsValidASectionForQuote(this.props.formId, this.props.ignore_sections)) {
  //     return;
  //   }
  //   if (!this.props.onQuoteRequest) {
  //     return;
  //   }
  // */}
  //
  //   const authToken = document.getElementsByName('authenticity_token')[0].value;
  //   var variantId = (this.props.itemId !== '') ? (this.props.itemId) : (document.getElementsByName('variant_id')[0].value);
  //
  //   if (this.props.variant !== null && this.props.variant !== ''){
  //     variantId = this.props.variant;
  //   }
  //
  //   this.props.onQuoteRequest(
  //     this.prepareData(),
  //     authToken,
  //     variantId,
  //     this.props.product_quote_number,// this.props.parameters.get('product_quote_number'),
  //   );
  // }

  // prepareData() {
  //   const options = {};
  //   this.props.suppliers.forEach((s) => {
  //     options[s] = this.props.parameters;
  //   });
  //   return options;
  // }

  render() {
    return (
      <div className="mb-3 d-grid">
        <button
          type="button"
          className={this.props.className}
          onClick={this.props.onClick}>
          {this.props.label}
        </button>
      </div>
    );
  }
}

InstantQuote.defaultProps = {
  className: 'btn btn-block btn-orange',
  label    : 'GET A QUOTE',
};

export default InstantQuote;
